module.exports = __webpack_public_path__ + "static/media/lightbulb-icon.fd9a207f.svg";